import { CommonDataService } from './../../../../core/services/common-data.service';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import {
  deepCopy,
  getDataScopeByPermission,
  getFacilityByPermission,
  getForwarderByPermission,
  isNullOrEmpty,
} from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { RfqSettingService } from '../../service/rfq-setting.service';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { Dropdown } from 'primeng/dropdown';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { CommonService } from '../../service/common.service';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { ExpenseService } from 'src/app/core/services/expense.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { endOfDay, startOfDay } from 'date-fns';

@Component({
  selector: 'laas-rfq-setting',
  templateUrl: './rfq-setting.component.html',
  styleUrls: ['./rfq-setting.component.scss'],
})
export class RfqSettingComponent
  extends SessionBaseComponent
  implements OnInit
{
  readonly preferenceKey: string;
  readonly preferenceKey2: string;
  readonly permissionCode = PermissionConstants.ViewRFQSetting;
  currentLang: string = this.laasSetting.language;
  @ViewChild('effectDate') effectDate!: CalendarComponent;

  shippingTypeOptions: any[] = [];
  feeTypeOptions: any[] = [];
  calculationUnitOptions: any[] = [];
  currencyOptions: any[] = [];
  pickupLocationOptions: any[] = [];
  searchForm: any;
  isSearchFormOpen: boolean;
  forwarderOptions: any[] = [];
  rfqStatusOptions: any[] = [];
  customerOptions: any[] = [];
  incoTermOptions: any[] = [];
  rfqCategoryTypeOptions: any[] = [];
  countryOptions: any[] = [];
  allCityOptions: any[] = [];
  allAreaOptions: any[] = [];
  expressTermOptions: any[] = [];
  allExpressAreaOptions: any[] = [];

  yesNoOption: any[] = [];
  selectedRfqData: any[]; //xx
  isLoading: boolean = false;
  searchResults: any[] = [];
  detailColumns: any[] = [];
  columns: any[];
  isShowUploadRFQModal: boolean = false;
  facilityOptions: any[] = [];
  isConsolidationOptions: any[] = [];

  showRFQApplyBtn: boolean = true;
  showRFQRecallBtn: boolean = true;
  showRFQDeleteBtn: boolean = true;
  showRFQApprovedBtn: boolean = true;
  showRFQInvalidBtn: boolean = true;
  showCreateBtn: boolean = true;
  showRFQDownloadBtn: boolean = false;
  defaultEffectDate: Date[];

  constructor(
    injector: Injector,
    private rfqSettingService: RfqSettingService,
    private commonService: CommonService,
    private dropdownOptionsService: DropdownOptionsService,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private commonDataService: CommonDataService,
    private dOService: DeliveryOrderService,
    private expenseService: ExpenseService,
    private fb: FormBuilder
  ) {
    super(injector);

    this.preferenceKey = UserPreferenceConstants.RfqSettingSearchMain;
    this.preferenceKey2 = UserPreferenceConstants.RfqSettingSearchDetail;

    this.searchForm = this.fb.group({
      forwarderList: [],
      startSeqNo: null,
      endSeqNo: null,
      fromLocation: [null],
      toLocation: [null],
      statusList: null,
      rfqCategoryList: null,
      isActivated: 1,
      consigneeKey: null,
      effectDate: null,
      shippingType: null,
      incoTerm: null,
      facilityList: [],
      facility: null,
      isConsolidation: null,
      effectStartDate: startOfDay(new Date()),
      effectEndDate: endOfDay(new Date()),
    });

    this.isSearchFormOpen = true;
    this.selectedRfqData = [];

    let newDate = new Date();
    this.defaultEffectDate = [startOfDay(new Date()), endOfDay(new Date())];

    this.columns = [
      { field: 'seqNo', header: 'RFQMaintenance.MainTable.RFQNum', sort: true },
      { field: 'facility', header: 'RFQMaintenance.MainTable.Facility', sort: true},
      { field: 'forwarder', header: 'RFQMaintenance.MainTable.Forwarder', sort: true },
      { field: 'status', header: 'RFQMaintenance.MainTable.Status', sort: true },
      { field: 'fromCountry', header: 'RFQMaintenance.MainTable.OriginCountry', sort: true },
      { field: 'fromCity', header: 'RFQMaintenance.MainTable.OriginCity', sort: true },
      { field: 'fromArea', header: 'RFQMaintenance.MainTable.OriginArea', sort: true },
      { field: 'expressFromArea', header: 'RFQMaintenance.MainTable.OriginCourierCity', sort: true },
      { field: 'toCountry', header: 'RFQMaintenance.MainTable.DestinationCountry', sort: true },
      { field: 'toCity', header: 'RFQMaintenance.MainTable.DestinationCity', sort: true },
      { field: 'toArea', header: 'RFQMaintenance.MainTable.DestinationArea', sort: true },
      { field: 'expressToArea', header: 'RFQMaintenance.MainTable.DestinationCourierCity', sort: true },
      { field: 'currency', header: 'RFQMaintenance.MainTable.AccountingCurrency', sort: true },
      { field: 'rfqCategory', header: 'RFQMaintenance.MainTable.DocumentType', sort: true },
      { field: 'shippingType', header: 'RFQMaintenance.SubTable.ShippingMethod', sort: true },
      { field: 'isConsolidation', header: 'RFQMaintenance.MainTable.IsConsolidation', sort: true },
      { field: 'awbAddress', header: 'RFQMaintenance.MainTable.PickUpAddress', sort: true },
      { field: 'expressTerm', header: 'RFQMaintenance.MainTable.CourierDeliveryCondition', sort: true },
      { field: 'consigneekey', header: 'RFQMaintenance.MainTable.Customerkey', sort: true },
      { field: 'consigneeName', header: 'RFQMaintenance.MainTable.Customer', sort: true },
      { field: 'effectStartDate', header: 'RFQMaintenance.MainTable.EffectiveStart', dataType: 'date', sort: true },
      { field: 'effectEndDate', header: 'RFQMaintenance.MainTable.EffectiveEnd', dataType: 'date', sort: true },
      { field: 'isActivated', header: 'RFQMaintenance.MainTable.IsActivated', sort: true },
      { field: 'remark', header: 'RFQMaintenance.MainTable.Remarks', sort: true },
      { field: 'createUser', header: 'RFQMaintenance.MainTable.CreateBy', sort: true },
      { field: 'createDt', header: 'RFQMaintenance.MainTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateUser', header: 'RFQMaintenance.MainTable.UpdateBy', sort: true },
      { field: 'updateDt', header: 'RFQMaintenance.MainTable.UpdateTime',  dataType: 'date', sort: true },

    ];

    this.detailColumns = [
      { field: 'feeType', header: 'RFQMaintenance.SubTable.CostType', sort: true },
      { field: 'incoTerm', header: 'RFQMaintenance.SubTable.TradeTerm', sort: true },
      { field: 'shippingSectionDesc', header: 'RFQMaintenance.SubTable.TransportSectionDescription', sort: true },
      { field: 'currency', header: 'RFQMaintenance.SubTable.AccountingCurrency', sort: true },
      { field: 'unitPrice', header: 'RFQMaintenance.SubTable.UniPrice', sort: true },
      { field: 'calculationUnit', header: 'RFQMaintenance.SubTable.CalculationUnit', sort: true },
      { field: 'intervalUnitStart', header: 'RFQMaintenance.SubTable.CalculationRangeStart', sort: true },
      { field: 'intervalUnitEnd', header: 'RFQMaintenance.SubTable.CalculationRangeEnd', sort: true },
      { field: 'minimalCharge', header: 'RFQMaintenance.SubTable.MinimumCost', sort: true },
      { field: 'isTieredGroup', header: 'RFQMaintenance.SubTable.IsRFQ', sort: true },
      { field: 'remark', header: 'RFQMaintenance.SubTable.Remarks', sort: true },
      { field: 'createUser', header: 'RFQMaintenance.SubTable.CreateBy', sort: true },
      { field: 'createDt', header: 'RFQMaintenance.SubTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateUser', header: 'RFQMaintenance.SubTable.UpdateBy', sort: true },
      { field: 'updateDt', header: 'RFQMaintenance.SubTable.UpdateTime', dataType: 'date', sort: true }

    ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options
          .filter((x: any) => {
            return (
              this.userProfile.userType == UserType.SuperAdmin.toString() ||
              this.userProfile.userType == UserType.Shipping.toString() ||
              getForwarderByPermission(
                this.userProfile,
                this.permissionCode
              ).includes(x.optionCode)
            );
          })
          .map((x) => ({ label: x.optionDesc, value: x.optionCode }));
      },
    });

    this.dropdownOptionsService.getIncoTermOptions().subscribe({
      next: (options: any[]) => {
        this.incoTermOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
        this.incoTermOptions.unshift({
          label: 'ALL',
          value: 'ALL',
        });
      },
    });

    this.dropdownOptionsService.getRFQStatusOptions().subscribe({
      next: (options: any[]) => {
        this.rfqStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: Number(x.optionCode),
        }));
      },
    });

    this.dropdownOptionsService.getRfqCategoryTypeOptions().subscribe({
      next: (options: any[]) => {
        this.rfqCategoryTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionsService.findFeeTypeByFeeTypeCategory('RFQ').subscribe({
      next: (options: any[]) => {
        this.feeTypeOptions = options.map((x) => ({
          label: x.feeTypeName,
          value: x.feeTypeCode,
        }));
      },
    });

    this.dropdownOptionsService
      .findFacilityOptionsByOptionType('ShippingType')
      .subscribe({
        next: (options: any[]) => {
          this.shippingTypeOptions = options.map((x) => ({
            label: x.optionDesc,
            value: x.optionCode,
          }));
        },
      });

    this.dropdownOptionsService
      .findFacilityOptionsByOptionType('CalculationUnit')
      .subscribe({
        next: (options: any[]) => {
          this.calculationUnitOptions = options.map((x) => ({
            label: x.optionDesc,
            value: x.optionCode,
          }));
        },
      });

    this.dropdownOptionsService.getPickupLocationOptions().subscribe({
      next: (options: any[]) => {
        this.pickupLocationOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.commonService.getCurrencyOptions().subscribe({
      next: (result) => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}-${x.currency_name}`,
            value: x.currency_code,
          };
        });
      },
    });

    this.yesNoOption = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 },
    ];

    let userType = this.userProfile.userType;

    // 申請
    if (
      userType == UserType.SuperAdmin.toString() ||
      this.permissionCodes.includes(PermissionConstants.BtnRFQApply)
    ) {
      this.showRFQApplyBtn = false;
    }

    // 撤回
    if (
      userType == UserType.SuperAdmin.toString() ||
      this.permissionCodes.includes(PermissionConstants.BtnRFQRecall)
    ) {
      this.showRFQRecallBtn = false;
    }

    // 核准
    if (
      userType == UserType.SuperAdmin.toString() ||
      this.permissionCodes.includes(PermissionConstants.BtnRFQApproved)
    ) {
      this.showRFQApprovedBtn = false;
    }

    // 刪除
    if (
      userType == UserType.SuperAdmin.toString() ||
      this.permissionCodes.includes(PermissionConstants.BtnRFQDelete)
    ) {
      this.showRFQDeleteBtn = false;
    }

    // 作廢
    if (
      userType == UserType.SuperAdmin.toString() ||
      this.permissionCodes.includes(PermissionConstants.BtnRFQInvalid)
    ) {
      this.showRFQInvalidBtn = false;
    }

    if (
      userType == UserType.SuperAdmin.toString() ||
      this.permissionCodes.includes(PermissionConstants.CreateRFQ)
    ) {
      this.showCreateBtn = false;
    }

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options
          .filter((x) => {
            return (
              this.userProfile.userType == UserType.SuperAdmin.toString() ||
              getFacilityByPermission(
                this.userProfile,
                this.permissionCode
              ).includes(null) ||
              getFacilityByPermission(
                this.userProfile,
                this.permissionCode
              ).includes(x.optionCode)
            );
          })
          .map((x) => ({ label: x.optionDesc, value: x.optionCode }));
      },
    });

    this.isConsolidationOptions = [
      { label: 'ALL', value: null },
      { label: 'N', value: 'N' },
      { label: 'Y', value: 'Y' },
    ];

    // init search from route data
    const routeData = this.routeStateService.getCurrentAndConsume()?.data;
    if (routeData) {
      this.searchForm.patchValue(routeData);
      this.searchRfq();
    }
  }

  // ===== 表單初始化 =====
  initializeForm(): void {
    this.searchForm = this.fb.group({
      forwarderList: [],
      startSeqNo: null,
      endSeqNo: null,
      fromLocation: [null],
      toLocation: [null],
      statusList: null,
      rfqCategoryList: null,
      isActivated: 1,
      consigneeKey: null,
      effectDate: null,
      shippingType: null,
      incoTerm: null,
      facilityList: [],
      facility: null,
      isConsolidation: null,
      effectStartDate: startOfDay(new Date()),
      effectEndDate: endOfDay(new Date()),
    });
  }

  // ===== Options Ready 事件處理 =====
  onCountryOptionsReady(options: any[]): void {
    this.countryOptions = options.map((x) => ({
      label: x.countryName || x.label,
      value: x.countryCode || x.value,
    }));
    this.countryOptions.unshift({ label: 'ALL', value: 'ALL' });
    console.log('Country options ready:', this.countryOptions.length);
  }

  onCityOptionsReady(options: any[]): void {
    this.allCityOptions = options.map((x) => ({
      label: x.cityName || x.name || x.label,
      value: x.cityCode || x.seqNo?.toString() || x.value,
    }));
    this.allCityOptions.unshift({ label: 'ALL', value: 'ALL' });
    console.log('City options ready:', this.allCityOptions.length);
  }

  onAreaOptionsReady(options: any[]): void {
    this.allAreaOptions = options.map((x) => ({
      label: x.areaName || x.label,
      value: x.areaCode || x.value,
    }));
    console.log('Area options ready:', this.allAreaOptions);
  }

  onRegionOptionsReady(options: any[]): void {
    // 如果需要處理 region options
    console.log('Region options ready:', options.length);
  }

  // 新增：Express Area 選項準備完成
  onExpressAreaOptionsReady(options: any[]): void {
    this.allExpressAreaOptions = options.map((x) => ({
      label: x.label,
      value: x.value,
    }));
    console.log(
      'Express Area options ready:',
      this.allExpressAreaOptions.length
    );
  }

  // ===== 位置選擇完成事件 =====
  onFromLocationComplete(location: any): void {
    console.log('起運地選擇完成:', location);
    console.log('國家:', location.country);
    console.log('城市:', location.city);
    console.log('地區:', location.area);
    console.log('快遞區域:', location.expressArea); // 更新
  }

  onToLocationComplete(location: any): void {
    console.log('目的地選擇完成:', location);
    console.log('國家:', location.country);
    console.log('城市:', location.city);
    console.log('地區:', location.area);
    console.log('快遞區域:', location.expressArea); // 更新
  }

  getCustomerOptionsByKey(event: any, dropdown: Dropdown): void {
    const key: string = event.filter;
    if (key != null && key.length > 1) {
      this.notificationSubScriptionService
        .getCustomerOptionsByKey(key)
        .subscribe({
          next: (options: any[]) => {
            this.customerOptions = options.map((x) => ({
              label: x.customerCode + '-' + x.customerName + '-' + x.engName,
              value: x.customerCode,
            }));
          },
        });
    }
  }

  resetClickBtn(event: any): void {
    this.searchForm.reset();
    this.effectDate.ngOnInit();
    this.searchForm.controls.effectStartDate.setValue(startOfDay(new Date()));
    this.searchForm.controls.effectEndDate.setValue(endOfDay(new Date()));
  }

  searchBtnClick(): void {
    this.selectedRfqData = [];
    this.searchRfq();
  }

  // ===== 主要搜尋方法 =====
  searchRfq(): void {
    this.isLoading = true;

    try {
      // 驗證搜尋條件
      if (!this.validateSearchForm()) {
        this.isLoading = false;
        return;
      }

      // 設定 facility
      this.setFacilityValue();

      // 轉換表單資料為 API 參數格式 - 使用 getRawValue()
      const params = this.convertLocationDataToApiParams(
        this.searchForm.getRawValue()
      );

      // 加入權限資料範圍
      params.dataScopes = getDataScopeByPermission(
        this.userProfile,
        this.permissionCode
      );

      console.log('準備發送的 API 參數:', params);

      this.rfqSettingService.searchRfqSetting(params).subscribe({
        next: (result) => {
          this.isSearchFormOpen = false;
          this.searchResults = result;
          this.isLoading = false;
          console.log('搜尋成功，結果筆數:', result?.length || 0);
        },
        error: (err: any) => {
          console.error('搜尋發生錯誤:', err);
          this.toastErrorMessage(err.error);
          this.isLoading = false;
        },
      });
    } catch (error) {
      console.error('搜尋方法執行錯誤:', error);
      this.isLoading = false;
      this.toastService.error('搜尋發生未預期錯誤');
    }
  }

  private setFacilityValue(): void {
    try {
      let facilityList = this.searchForm.getRawValue().facilityList; // 使用 getRawValue

      if (facilityList == null || facilityList.length == 0) {
        this.searchForm.controls.facility.setValue(this.laasSetting.facility);
      } else {
        let temp = facilityList.toString();
        this.searchForm.controls.facility.setValue(temp);
      }
    } catch (error) {
      console.error('設定 facility 值時發生錯誤:', error);
      this.searchForm.controls.facility.setValue(
        this.laasSetting?.facility || ''
      );
    }
  }

  async searchDetailClick(event: any): Promise<void> {
    const rowData = event.rowData;
    const isClosed = event.expanded;
    console.log('rowData:', rowData);
    if (isClosed) {
      return;
    }
    rowData.rfqDetails = await this.rfqSettingService.getRfqDetail(
      rowData.seqNo
    );
    this.isLoading = false;
  }

  private validateSearchForm(): boolean {
    const formValue = this.searchForm.value;

    try {
      // 序號範圍驗證
      if (formValue.startSeqNo != null && formValue.endSeqNo != null) {
        if (formValue.startSeqNo > formValue.endSeqNo) {
          this.toastService.warn(
            this.translateService.instant('RFQSetting.Alert.QuoteNumber')
          );
          console.log('序號範圍驗證失敗: startSeqNo > endSeqNo');
          return false;
        }
      }

      // 生效日期範圍驗證
      if (
        formValue.effectStartDate != null &&
        formValue.effectEndDate != null
      ) {
        if (formValue.effectStartDate > formValue.effectEndDate) {
          this.toastService.warn(
            this.translateService.instant('RFQSetting.Alert.EffectiveGreater')
          );
          console.log('日期範圍驗證失敗: effectStartDate > effectEndDate');
          return false;
        }
      }

      // 位置邏輯驗證
      const hasFromLocation = formValue.fromLocation?.country;
      const hasToLocation = formValue.toLocation?.country;

      // 如果有起運地但沒有城市
      if (hasFromLocation && !formValue.fromLocation?.city) {
        console.warn('起運地國家已選擇但未選擇城市');
        // 根據業務需求決定是否要阻止搜尋
        // this.toastService.warn('請選擇起運城市');
        // return false;
      }

      // 如果有目的地但沒有城市
      if (hasToLocation && !formValue.toLocation?.city) {
        console.warn('目的地國家已選擇但未選擇城市');
        // 根據業務需求決定是否要阻止搜尋
        // this.toastService.warn('請選擇目的城市');
        // return false;
      }

      // Forwarder List 驗證
      if (
        formValue.forwarderList &&
        Array.isArray(formValue.forwarderList) &&
        formValue.forwarderList.length === 0
      ) {
        console.log('Forwarder List 為空陣列，將被忽略');
      }

      // Facility List 驗證
      if (
        formValue.facilityList &&
        Array.isArray(formValue.facilityList) &&
        formValue.facilityList.length === 0
      ) {
        console.log('Facility List 為空陣列，將使用預設 facility');
      }

      // 特殊業務邏輯驗證
      if (
        formValue.isConsolidation === true &&
        (!hasFromLocation || !hasToLocation)
      ) {
        console.warn('併櫃運輸需要完整的起運地和目的地');
        // this.toastService.warn('併櫃運輸請選擇完整的起運地和目的地');
        // return false;
      }

      // 日期不能是未來太遠的日期（例如超過一年）
      if (formValue.effectStartDate) {
        const oneYearFromNow = new Date();
        oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

        if (formValue.effectStartDate > oneYearFromNow) {
          console.warn('生效開始日期不能超過一年後');
          this.toastService.warn('生效開始日期不能超過一年後');
          return false;
        }
      }

      console.log('表單驗證通過');
      return true;
    } catch (error) {
      console.error('驗證過程發生錯誤:', error);
      this.toastService.error('表單驗證發生錯誤');
      return false;
    }
  }

  seqNoLinkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo(
      '/Setting/RfqHeaderDetail',
      rowData,
      true
    );
  }

  accordionTabOpen(): void {
    this.isSearchFormOpen = true;
  }

  addBtn() {
    this.routeStateService.navigateTo('/Setting/RfqCreation', null);
  }

  uploadRFQBtn() {
    this.routeStateService.navigateTo('/Setting/RfqUpload', null);
  }

  uploadRFQ(event: any): void {
    console.log('uploadRFQ');

    this.translateService.get('Common.Message.SuccessSave').subscribe({
      next: (msg) => {
        this.toastService.success(msg);
      },
    });
  }

  getRFQExcel() {
    if (
      this.searchForm.value.startSeqNo != null &&
      this.searchForm.value.endSeqNo != null
    ) {
      if (this.searchForm.value.startSeqNo > this.searchForm.value.endSeqNo) {
        this.toastService.warn(
          this.translateService.instant('RFQSetting.Alert.QuoteNumber')
        );
        this.loader.hide();
        return;
      }
    }

    let facilityList = this.searchForm.value.facilityList;
    if (facilityList == null || facilityList.length == 0) {
      this.searchForm.controls.facility.setValue(this.laasSetting.facility);
    } else {
      let temp = facilityList.toString();
      this.searchForm.controls.facility.setValue(temp);
    }

    const params = deepCopy(this.searchForm.value);
    params.language = this.laasSetting.language;
    params.dataScopes = getDataScopeByPermission(
      this.userProfile,
      this.permissionCode
    );

    this.rfqSettingService.getRFQExcel(params).subscribe({
      next: (result) => {
        if (result == null || result.size == 0) {
          this.toastService.info(
            this.translateService.instant('RFQSetting.Info.NoData')
          );
          this.loader.hide();
        } else {
          const file = result;
          file.name = 'RFQ REPORT';
          const url = URL.createObjectURL(file);
          let a: any = document.createElement('a');
          a.href = url;
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
          this.loader.hide();
        }
      },
      complete: () => {},
    });
  }

  //申請
  applyClickBtn(event: any): void {
    this.translateService.get('RFQSetting.Confirm.ConfirmApply').subscribe({
      next: (confirmApply) => {
        this.confirmationService.confirm({
          target: event.target,
          message: confirmApply,
          icon: 'pi pi-info-circle',
          accept: () => {
            this.applyRfqSetting(event);
          },
          reject: () => {
            // reject action
          },
        });
      },
    });
  }

  applyRfqSetting(event: any): void {
    if (
      this.selectedRfqData.some(
        (x) => x.status !== this.selectedRfqData[0].status
      )
    ) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.MaintenanceStatus')
      );
      return;
    }
    if (this.selectedRfqData.every((x) => x.status === 2)) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.ApplicationInProgress')
      );
      return;
    }
    if (this.selectedRfqData.every((x) => [3, 6].includes(x.status))) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.ProcceedingApplication')
      );
      return;
    }
    if (this.selectedRfqData.some((x) => x.isActivated !== 1)) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.DataValid')
      );
      return;
    }

    var rows = deepCopy(this.selectedRfqData);
    rows?.forEach((x) => {
      x.status = 2;
      x.updateUser = this.userProfile.userName;
      this.rfqSettingService.updateStatus(x).subscribe({
        next: (result) => {
          this.toastService.success(
            this.translateService.instant('RFQSetting.Success.UpdateInProgress')
          );
          this.searchRfq();
        },
      });
    });
    this.selectedRfqData = [];
  }

  //撤回
  withdrawClickBtn(event: any): void {
    this.translateService.get('RFQSetting.Confirm.ConfirmWithdraw').subscribe({
      next: (confirmWithdraw) => {
        this.confirmationService.confirm({
          target: event.target,
          message: confirmWithdraw,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.withdrawRfqSetting(event);
          },
          reject: () => {
            // reject action
          },
        });
      },
    });
  }

  withdrawRfqSetting(event: any): void {
    if (
      this.selectedRfqData.some(
        (x) => x.status !== this.selectedRfqData[0].status
      )
    ) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.MaintenanceStatus')
      );
      return;
    }
    if (this.selectedRfqData.every((x) => [1, 3, 6].includes(x.status))) {
      this.toastService.warn(
        this.translateService.instant(
          'RFQSetting.Alert.OnlyApplicationWithdrawn'
        )
      );
      return;
    }
    if (this.selectedRfqData.some((x) => x.isActivated !== 1)) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.DataValid')
      );
      return;
    }

    var rows = deepCopy(this.selectedRfqData);
    rows?.forEach((x) => {
      x.status = 1;
      x.updateUser = this.userProfile.userName;
      this.rfqSettingService.updateStatus(x).subscribe({
        next: (result) => {
          this.toastService.success(
            this.translateService.instant('RFQSetting.Success.UpdatePending')
          );
          this.searchRfq();
        },
      });
    });
    this.selectedRfqData = [];
  }

  //刪除
  deleteClickBtn(event: any): void {
    if (this.selectedRfqData.length == 0) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.Tick')
      );
      return;
    }

    var seqNo = this.selectedRfqData.map((x) => x.seqNo);
    this.confirmationService.confirm({
      target: event.target,
      message: this.translateService.instant(
        'RFQSetting.Confirm.ConfirmDelete'
      ),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        //confirm action
        seqNo.forEach((x) => {
          this.rfqSettingService.deleteRFQ(x).subscribe({
            next: (result) => {
              this.toastService.info('刪除成功');
            },
            complete: () => {
              this.searchRfq();
            },
          });
        });
        this.selectedRfqData = [];
      },
      reject: () => {
        //reject action
      },
    });
  }

  //核准
  approveClickBtn(event: any): void {
    this.translateService.get('RFQSetting.Confirm.ConfirmApprove').subscribe({
      next: (confirmApprove) => {
        this.confirmationService.confirm({
          target: event.target,
          message: confirmApprove,
          icon: 'pi pi-info-circle',
          accept: () => {
            this.approveRfqSetting(event);
          },
          reject: () => {
            // reject action
          },
        });
      },
    });
  }

  // 下載
  downloadClickBtn(event: any): void {
    if (this.selectedRfqData.length > 0) {
      var seqNos = this.selectedRfqData
        .map((x) => x.seqNo.toString())
        .join(',');

      this.commonDataService.getSystemParam('RFQSetting').subscribe({
        next: (result) => {
          var searchObj = {
            sn: result[0].sn,
            version: result[0].version,
          };

          this.dOService.downloadFile(searchObj).subscribe((x) => {
            var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

            var blobFile = this.blobToFile(blob, 'RFQ.xlsx');
            this.expenseService
              .downloadRfqByExcel(blobFile, seqNos)
              .subscribe((x) => {
                blob = new Blob([x], { type: 'application/octet-stream' });
                let downloadURL = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.href = downloadURL;
                link.download = 'RFQ.xlsx';
                link.click();
              });
          });
        },
      });
    }
  }

  blobToFile = (blob: Blob, fileName: string): File => {
    var b: any = blob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    return <File>blob;
  };

  approveRfqSetting(event: any): void {
    if (this.selectedRfqData.length == 0) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.Tick')
      );
      return;
    }

    if (
      this.selectedRfqData.some(
        (x) => x.status !== this.selectedRfqData[0].status
      )
    ) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.MaintenanceStatus')
      );
      return;
    }
    if (this.selectedRfqData.every((x) => x.status === 6)) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.ApplicationApproved')
      );
      return;
    }
    if (this.selectedRfqData.every((x) => [1, 3].includes(x.status))) {
      this.toastService.warn(
        this.translateService.instant(
          'RFQSetting.Alert.OnlyApplicationApproved'
        )
      );
      return;
    }
    if (this.selectedRfqData.some((x) => x.isActivated !== 1)) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.DataValid')
      );
      return;
    }

    var rows = deepCopy(this.selectedRfqData);
    rows?.forEach((x) => {
      x.status = 6;
      x.updateUser = this.userProfile.userName;
      this.rfqSettingService.updateStatus(x).subscribe({
        next: (result) => {
          this.toastService.success(
            this.translateService.instant('RFQSetting.Success.UpdateApproved')
          );
          this.searchRfq();
        },
      });
    });
    this.selectedRfqData = [];
  }

  //作廢
  cancelClickBtn(event: any): void {
    this.translateService.get('RFQSetting.Confirm.ConfirmCancel').subscribe({
      next: (confirmCancel) => {
        this.confirmationService.confirm({
          target: event.target,
          message: confirmCancel,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.cancelRfqSetting(event);
          },
          reject: () => {
            // reject action
          },
        });
      },
    });
  }

  cancelRfqSetting(event: any): void {
    if (this.selectedRfqData.some((x) => x.isActivated !== 1)) {
      this.toastService.warn(
        this.translateService.instant('RFQSetting.Alert.DataValid')
      );
      return;
    }

    var rows = deepCopy(this.selectedRfqData);
    rows?.forEach((x) => {
      x.isActivated = 0;
      x.updateUser = this.userProfile.userName;
      this.rfqSettingService.updateStatus(x).subscribe({
        next: (result) => {
          this.translateService.get('Common.Message.SuccessSave').subscribe({
            next: (msg) => {
              this.toastService.success(msg);
              this.searchRfq();
            },
          });
        },
      });
    });
    this.selectedRfqData = [];
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'effectDate':
        this.searchForm.controls.effectStartDate.setValue(date.startDate);
        this.searchForm.controls.effectEndDate.setValue(date.endDate);
        break;
    }
  }

  // ===== 更新的資料轉換方法 =====
  private convertLocationDataToApiParams(formValue: any): any {
    // 使用 getRawValue() 取得完整資料（包含 disabled 的控制項）
    const rawValue = this.searchForm.getRawValue();
    const params = { ...rawValue };

    console.log('Form value (可能缺少 disabled 的值):', formValue);
    console.log('Raw value (包含所有值):', rawValue);

    // 轉換起運地
    if (rawValue.fromLocation) {
      params.fromCountry = rawValue.fromLocation.country;
      params.fromCity = rawValue.fromLocation.city;
      params.fromArea = rawValue.fromLocation.area;
      params.expressFromArea = rawValue.fromLocation.expressArea;
      delete params.fromLocation;
    } else {
      // 確保空值時也有對應欄位
      params.fromCountry = null;
      params.fromCity = null;
      params.fromArea = null;
      params.expressFromArea = null;
    }

    // 轉換目的地
    if (rawValue.toLocation) {
      params.toCountry = rawValue.toLocation.country;
      params.toCity = rawValue.toLocation.city;
      params.toArea = rawValue.toLocation.area;
      params.expressToArea = rawValue.toLocation.expressArea;
      delete params.toLocation;
    } else {
      // 確保空值時也有對應欄位
      params.toCountry = null;
      params.toCity = null;
      params.toArea = null;
      params.expressToArea = null;
    }

    // 處理陣列欄位
    if (params.forwarderList && Array.isArray(params.forwarderList)) {
      params.forwarderList =
        params.forwarderList.length > 0 ? params.forwarderList : null;
    }

    if (params.facilityList && Array.isArray(params.facilityList)) {
      params.facilityList =
        params.facilityList.length > 0 ? params.facilityList : null;
    }

    console.log('轉換後的 API 參數:', params);
    return params;
  }

  // ===== 更新的搜尋條件取得方法 =====
  getSearchCriteria(): any {
    const formValue = this.searchForm.value;

    const criteria = {
      // 基本搜尋條件
      forwarderList: formValue.forwarderList || [],
      startSeqNo: formValue.startSeqNo,
      endSeqNo: formValue.endSeqNo,
      statusList: formValue.statusList,
      rfqCategoryList: formValue.rfqCategoryList,
      isActivated: formValue.isActivated,
      consigneeKey: formValue.consigneeKey,
      effectDate: formValue.effectDate,
      shippingType: formValue.shippingType,
      incoTerm: formValue.incoTerm,
      facilityList: formValue.facilityList || [],
      facility: formValue.facility,
      isConsolidation: formValue.isConsolidation,
      effectStartDate: formValue.effectStartDate,
      effectEndDate: formValue.effectEndDate,

      // 起運地資訊
      fromCountry: formValue.fromLocation?.country || null,
      fromCity: formValue.fromLocation?.city || null,
      fromArea: formValue.fromLocation?.area || null,
      expressFromArea: formValue.fromLocation?.expressArea || null, // 更新

      // 目的地資訊
      toCountry: formValue.toLocation?.country || null,
      toCity: formValue.toLocation?.city || null,
      toArea: formValue.toLocation?.area || null,
      expressToArea: formValue.toLocation?.expressArea || null, // 更新

      // 計算字段
      hasCompleteFromLocation: !!(
        formValue.fromLocation?.country && formValue.fromLocation?.city
      ),
      hasCompleteToLocation: !!(
        formValue.toLocation?.country && formValue.toLocation?.city
      ),
      isInternational:
        formValue.fromLocation?.country &&
        formValue.toLocation?.country &&
        formValue.fromLocation.country !== formValue.toLocation.country,
      hasDateRange: !!(formValue.effectStartDate && formValue.effectEndDate),
      hasSeqNoRange: !!(formValue.startSeqNo && formValue.endSeqNo),
    };

    console.log('目前搜尋條件:', criteria);
    return criteria;
  }
}
